module.exports = require("./angular-material.js");
require("./angular-material.css");


//////////////////
// WEBPACK FOOTER
// angular-material (bower component)
// module id = 447
// module chunks = 1